// extracted by mini-css-extract-plugin
export default {"main":"SubscriptionCancellationsPage_main__3Tt2P","menu":"SubscriptionCancellationsPage_menu__rKxb5","workArea":"SubscriptionCancellationsPage_workArea__GIrr7"};